/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Constants from "../../../../constants/constants";
import * as userCredentialService from "../../../../services/training/userCredentialService";
import * as auth from "../../Auth/_redux/authRedux";
import * as userService from "../../../../services/management/userService";
import { Modal, Button, Spinner } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import moment from 'moment';

const ProfileCard = (props) => {
  const { userProfileState, auth, onViewLogsReady } = props;
  const [userCredentials, setUserCredentials] = useState([]);
  const [showSessionsTable, setShowSessionsTable] = useState(false);
  const [userSessions, setUserSessions] = useState([]);
  const [userSessionLoading, setUserSessionLoading] = useState([]);

  useEffect(() => {
    if (userProfileState.id) {
      userCredentialService.getUserCredentialByUserId(userProfileState.id, false).then(res => {
        setUserCredentials(res);
      })
    }
  }, [userProfileState])

  const hideSessionsTable = () => {
    setShowSessionsTable(false);
  }

  const getUserSessions = useCallback(() => {
    if (!auth.isAdmin) {
      return;
    }
    setUserSessionLoading(true);
    setShowSessionsTable(true);
    userService.getUserSessions(userProfileState.id).then(res => {
      setUserSessions(res);
    }).catch(ex => {

    }).finally(() => setUserSessionLoading(false))
  }, [auth.isAdmin, userProfileState.id])

  useEffect(() => {
    if (onViewLogsReady) {
      onViewLogsReady(getUserSessions);
    }

    return () => {
      if (onViewLogsReady) {
        onViewLogsReady(null);
      }
    };
  }, [getUserSessions, onViewLogsReady]);

  const columns = [
    {
      name: "id",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        width: 1,
        print: false,
        download: false,
        setCellProps: () => ({
          'data-aes-field': 'actions',
          'data-aes-label': 'Actions'
        }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className="aes-admin-listing-actions">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={"https://maps.google.com/?q=" + userSessions[dataIndex].latitude + "," +  userSessions[dataIndex].longitude}
                className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
              >
                View Map
              </a>
            </div>
          );
        }
      },

    },
    {
      name: "dateLoggedIn",
      label: "Date Time",
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'date-logged-in',
          'data-aes-label': 'Date Time'
        }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <p>{moment(userSessions[dataIndex].dateLoggedIn).format("h:mm:ss a, MMMM Do YYYY")}</p>
          );
        }
      }
    },
    {
      name: "latitude",
      label: "Latitude",
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'latitude',
          'data-aes-label': 'Latitude'
        }),
      }
    },
    {
      name: "longitude",
      label: "Longitude",
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'longitude',
          'data-aes-label': 'Longitude'
        }),
      }
    },
  ];

  return (
    <>
      <div
        className="aes-user-detail-sidebar flex-row-auto offcanvas-mobile w-250px w-xxl-350px"
        id="kt_profile_aside"
      >
        <div className="card card-custom card-stretch">
          {/* begin::Body */}
          <div className="card-body pt-4">
            {/* begin::User */}
            <div className="d-flex align-items-center">
              <div className="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                <div
                  className="symbol-label img-block background-image-container"
                  style={{ backgroundImage: `url(${Constants.API_URL + userProfileState.imageUrl})` }}
                ></div>
                {/* style="background-i
                  mage:url('/metronic/theme/html/demo1/dist/assets/media/users/300_21.jpg')" */}
                <i className="symbol-badge bg-success"></i>
              </div>
              <div>
                <a
                  href="#"
                  className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                >
                  {userProfileState.firstName + " " + userProfileState.lastName}
                </a>
                <div className="text-muted">{userProfileState.roles}</div>
                <div className="mt-2">
                  <button
                    id="aes-user-profile-logs-action"
                    disabled={!auth.isAdmin}
                    onClick={getUserSessions}
                    className="btn btn-sm btn-primary font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1"
                  >
                    Logs
                  </button>

                </div>
              </div>
            </div>
            {/* end::User */}
            {/* begin::Contact */}
            <div className="py-9">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="font-weight-bold mr-2">Email:</span>
                <span className="text-muted text-hover-primary">
                  {userProfileState.email}
                </span>
              </div>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="font-weight-bold mr-2">Phone: </span>
                <span className="text-muted">{userProfileState.phoneNumber}</span>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span className="font-weight-bold mr-2">Location:</span>
                <span className="text-muted"> {userProfileState.location ? userProfileState.location : "-"}</span>
              </div>
            </div>
            {/* end::Contact */}
            {/* begin::Nav */}
            <div className="navi navi-bold navi-hover navi-active navi-link-rounded">
              {/* <div className="navi-item mb-2">
                <NavLink
                  to={"/management/user-profile/profile-overview/" + props.userId}
                  className="navi-link py-4"
                  activeClassName="active"
                >
                  <span className="navi-icon mr-2">
                    <span className="svg-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Design/Layers.svg"
                        )}
                      ></SVG>{" "}
                    </span>
                  </span>
                  <span className="navi-text font-size-lg">
                    Profile Overview
                  </span>
                </NavLink>
              </div> */}
              <div className="navi-item mb-2">
                <NavLink
                  to={"/management/user-profile/personal-information/" + props.userId}
                  className="navi-link py-4"
                  activeClassName="active"
                >
                  <span className="navi-icon mr-2">
                    <span className="svg-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/User.svg"
                        )}
                      ></SVG>{" "}
                    </span>
                  </span>
                  <span className="navi-text font-size-lg">
                    Personal Information
                  </span>
                </NavLink>
              </div>
              <div className="navi-item mb-2">
                <NavLink
                  to={"/management/user-profile/account-information/" + props.userId}
                  className="navi-link py-4"
                  activeClassName="active"
                >
                  <span className="navi-icon mr-2">
                    <span className="svg-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Code/Compiling.svg"
                        )}
                      ></SVG>{" "}
                    </span>
                  </span>
                  <span className="navi-text font-size-lg">
                    Company Information
                  </span>
                </NavLink>
              </div>
              {
                auth.isAdmin ?
                  <div className="navi-item mb-2">
                    <NavLink
                      to={"/management/user-profile/change-password/" + props.userId}
                      className="navi-link py-4"
                      activeClassName="active"
                    >
                      <span className="navi-icon mr-2">
                        <span className="svg-icon">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Shield-user.svg"
                            )}
                          ></SVG>{" "}
                        </span>
                      </span>
                      <span className="navi-text font-size-lg">
                        Change Password
                      </span>
                    </NavLink>
                  </div>
                  : <></>
              }

              <div className="navi-item mb-2">
                <NavLink
                  to={"/management/user-profile/credentials/" + props.userId}
                  className="navi-link py-4"
                  activeClassName="active"
                >
                  <span className="navi-icon mr-2">
                    <span className="svg-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Star.svg"
                        )}
                      ></SVG>{" "}
                    </span>
                  </span>
                  <span className="navi-text font-size-lg">
                    Credentials
                  </span>
                  <span className="navi-label">
                    <span className="label label-light-success label-rounded font-weight-bold">
                      {userCredentials.length}
                    </span>
                  </span>
                </NavLink>
              </div>
            </div>
            {/* end::Nav */}
          </div>
          {/* end::Body */}
        </div>
      </div>

      <Modal
        className='aes-user-sessions-modal'
        dialogClassName='aes-user-sessions-modal__dialog'
        contentClassName='aes-user-sessions-modal__content'
        size='lg'
        show={showSessionsTable}
        onHide={hideSessionsTable}
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>User Sessions</Modal.Title>
        </Modal.Header> */}
        <Modal.Body className='aes-user-sessions-modal__body'>
          <div className={`aes-user-sessions-listing ${userSessions.length === 0 ? 'aes-user-sessions-listing--empty' : ''}`}>
            <MUIDataTable
              className='aes-user-sessions-listing__surface'
              data={userSessions}
              title="User Sessions"
              columns={columns}
              options={{
                responsive: 'standard',
                rowsPerPage: 10,
                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                selectableRows: 'none',
                setTableProps: () => ({
                  className: 'aes-user-sessions-listing__table',
                }),
                downloadOptions: {
                  filename: 'User_Session.csv',
                  filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                  }
                },
                textLabels: {
                  body: {
                    noMatch: userSessionLoading ?
                      <Spinner animation="border" size="lg" variant="info" /> :
                      'Sorry, no matching records found.',
                  },
                }
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className='aes-user-sessions-modal__footer'>
          <Button variant="secondary" onClick={hideSessionsTable}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userProfileState: state.userProfile,
  auth: state.auth
});

export default connect(mapStateToProps, auth.actions)(ProfileCard);
